import { router } from '@inertiajs/vue3'

let loaded = false
let storedMeasurementId = null

export function loadGtagScript(measurementId) {
  const id = measurementId || storedMeasurementId
  return new Promise((resolve) => {
    if (loaded) { resolve(); return }
    loaded = true

    const script = document.createElement('script')
    script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`
    script.async = true
    script.onload = resolve
    script.onerror = resolve
    document.head.appendChild(script)

    window.gtag('event', 'page_view', {
      page_location: window.location.href,
      page_title: document.title,
    })
  })
}

export default {
  install(app, options = {}) {
    if (import.meta.env.SSR) {
      app.config.globalProperties.$gtag = () => {}
      app.provide('gtag', () => {})
      return
    }

    const { enabled = true, ga_measurement_id, ads_id, autoLoad = true } = options
    if (!enabled || !ga_measurement_id) {
      app.config.globalProperties.$gtag = () => {}
      app.provide('gtag', () => {})
      return
    }

    storedMeasurementId = ga_measurement_id

    window.dataLayer = window.dataLayer || []
    window.gtag = window.gtag || function () {
      window.dataLayer.push(arguments)
    }

    window.gtag('js', new Date())
    window.gtag('config', ga_measurement_id, { send_page_view: false })
    if (ads_id) {
      window.gtag('config', ads_id)
    }

    if (autoLoad) {
      const loadWhenIdle = () => {
        if (typeof window.requestIdleCallback === 'function') {
          window.requestIdleCallback(() => {
            loadGtagScript(ga_measurement_id)
          }, { timeout: 5000 })
        } else {
          setTimeout(() => loadGtagScript(ga_measurement_id), 5000)
        }
      }

      loadWhenIdle()
    }

    // Track Inertia navigations
    router.on('navigate', (event) => {
      if (window.gtag) {
        window.gtag('event', 'page_view', {
          page_location: event.detail.page.url,
          page_title: document.title,
        })
      }
    })

    app.config.globalProperties.$gtag = (...args) => window.gtag?.(...args)
    app.provide('gtag', (...args) => window.gtag?.(...args))
  }
}
